import { Component, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet, type Event,} from '@angular/router';
import { TitleService } from '@core/services/title.service';
import {
  NgProgressbar,
  NgProgressRef,
} from 'ngx-progressbar'
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgProgressbar],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private titleService = inject(TitleService);
  progressRef!: NgProgressRef;

  @ViewChild(NgProgressRef) progressBar!: NgProgressRef;

  private router = inject(Router);

  constructor() {
    this.router.events.subscribe((event: Event) => {
      this.checkRouteChange(event);
    });
  }

  ngOnInit(): void {
    this.titleService.init();
    // Session restore is handled before routing starts: the app initializer (see app.config.ts) runs the
    // OIDC discovery + token check and fills the store from the stored OAuth session.
    // Dismiss the pre-bootstrap splash screen now that the app shell is live. This was an inline <script> in
    // index.html; it was moved here so a strict CSP (script-src 'self') can forbid inline scripts entirely.
    document.getElementById('splash-screen')?.classList.add('remove');
  }

  checkRouteChange(routerEvent: Event) {
    if (routerEvent instanceof NavigationStart) {
      this.progressBar.start();
    }
    if (
      routerEvent instanceof NavigationEnd ||
      routerEvent instanceof NavigationCancel ||
      routerEvent instanceof NavigationError
    ) {
      setTimeout(() => {
        this.progressBar.complete();
      }, 200);
    }
  }
}
